module.exports = __webpack_public_path__ + "img/1570728299.9acc3bd7.jpg";